import React, { act, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Navbar, Drawer, Sidebar } from 'flowbite-react';
import './HeaderComponent.css';
import logsUserService from '../../services/UserLogServices';


const HeaderComponent = () => {
  const navigate = useNavigate();
  const name = sessionStorage.getItem('username') || sessionStorage.getItem('name');
  const lastName = sessionStorage.getItem('lastName') || sessionStorage.getItem('last_name');
  const is_qr = sessionStorage.getItem('is_qr');
  const is_chat = sessionStorage.getItem('is_chat');
  const token = sessionStorage.getItem('token');
  const idUser = sessionStorage.getItem('id_user');

  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const location = useLocation();

  const isActive = (path) => {
    // Verifica si la ruta actual comienza con el path proporcionado
    return location.pathname.startsWith(path) ? 'active' : '';
  }

  const handleLinkClick = () => {
    if (isOpen) {
      handleDrawerClick()
    }
  };

  const handleDrawerClick = () => {
    handleClose()
  }

  const formatSpeakerName = (name) => {
    // Verifica si el nombre ya contiene "Dr."
    if (name.startsWith('Dr.')) {
      return name;
    }
    // Si no, agrega "Dr." al inicio
    return `Dr. ${name}`;
  };

  const logout = () => {
    logsUserService(idUser, 'logout', window.location.href)
    sessionStorage.clear();
    navigate('/home')
  }

  const logsAction = (action) => {
    logsUserService(idUser, action, window.location.href);
  }

  return (
    <>
      <Navbar fluid rounded className='bg-transparent border-b-2 border-[#0055D1] rounded-0 ml-5 mr-5'>
        <Navbar.Brand>
          <img
            src="./logo_medicoinnovador_color.png"
            width="200"
            height="90"
            className="d-inline-block align-text-top p-2 mx-5"
            alt="Logo"
          />
        </Navbar.Brand>
        <div className="flex md:order-2 mr-5">
          <Navbar.Toggle className="button" onClick={handleOpen} />
        </div>
        <Navbar.Collapse className="ml-auto mr-5">
          <div className="flex flex-col items-end">
            <span className="text-sm text-dark-purple-800 mb-2 text-end">
              Bienvenido, <strong className='fw-bold'>{formatSpeakerName(name + ' ' + lastName)}</strong>
            </span>
            <div className="inline-flex" role="group">
              <Link
                to="/inicio"
                className={`nav-link Bebas-Neue text-items-nav`}
                style={{ color: 'inherit' }}
              >
                <button
                  type="button"
                  className={`px-4 py-2 rounded-l-full text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 ${isActive('/inicio')} ${is_qr || is_chat ? 'hidden' : 'block'}`}
                >
                  Inicio
                </button>
              </Link>
              <Link
                to="/agenda"
                className="nav-link Bebas-Neue text-items-nav"
                style={{ color: 'inherit' }}
              >
                <button
                  type="button"
                  onClick={() => handleLinkClick('/eventos')}
                  className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 ${isActive('/agenda')}  ${is_qr || is_chat ? 'rounded-l-full' : ''}`}
                >
                  Agenda
                </button>
              </Link>
              <Link
                to="/conferencistas"
                className="nav-link Bebas-Neue text-items-nav"
                style={{ color: 'inherit' }}
              >
                <button
                  type="button"
                  className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 ${isActive('/conferencistas')}`}
                >
                  Conferencistas
                </button>

              </Link>
              <Link
                to="/chatLive"
                className="nav-link Bebas-Neue text-items-nav"
                style={{ color: 'inherit' }}
              >
                <button
                  type="button"
                  className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 ${isActive('/chatLive')} ${is_chat ? 'block' : 'hidden'}`}
                >
                  Chat en vivo
                </button>

              </Link>
              <Link
                to="/certificados"
                className="nav-link Bebas-Neue text-items-nav"
                style={{ marginRight: '-15px' }}
              >
                <button
                  type="button"
                  className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 ${isActive('/certificados')} ${is_chat ? 'hidden' : 'block'}`}
                >
                  Certificado
                </button>
              </Link>
              <button
                type="button"
                className="w-24 h-10 flex items-center justify-center text-white bg-[#011965] rounded-full hover:text-[#0055D1] focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                onClick={logout}
              >
                Salir
              </button>
            </div>
          </div>
        </Navbar.Collapse>
      </Navbar>

      <Drawer open={isOpen} onClose={handleClose} className='drawer-personalited'>
        <Drawer.Header title="MENU" titleIcon={() => <></>} />
        <Drawer.Items>
          <Sidebar
            aria-label="Sidebar with multi-level dropdown example"
            className="[&>div]:bg-transparent [&>div]:p-0 px-0"
          >
            <img
              src="./logo_medicoinnovador_color.png"
              className="d-inline-block align-text-top text-center p-2 mx-5 w-40 h-24"
              alt="Logo"
            />
            <div className="flex flex-col flex-grow">
              <Sidebar.Items>
                <Sidebar.ItemGroup className="w-full">
                  <Link
                    to="/inicio"
                    className="nav-link Bebas-Neue text-items-nav w-full"
                    style={{ color: 'inherit' }}
                  >
                    <button
                      type="button"
                      className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 w-full ${isActive('/inicio')} ${is_qr || is_chat ? 'hidden' : 'block'}`}
                    >
                      Inicio
                    </button>
                  </Link>
                  <Link
                    to="/agenda"
                    className="nav-link Bebas-Neue text-items-nav w-full"
                    style={{ color: 'inherit' }}
                  >
                    <button
                      type="button"
                      onClick={() => handleLinkClick('/eventos')}
                      className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 w-full ${isActive('/agenda')}`}
                    >
                      Agenda
                    </button>
                  </Link>

                  <Link
                    to="/conferencistas"
                    className="nav-link Bebas-Neue text-items-nav w-full"
                    style={{ color: 'inherit' }}
                  >
                    <button
                      type="button"
                      className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 w-full ${isActive('/conferencistas')}`}
                    >
                      Conferencistas
                    </button>
                  </Link>
                  <Link
                    to="/chatLive"
                    className="nav-link Bebas-Neue text-items-nav w-full"
                    style={{ color: 'inherit' }}
                  >
                    <button
                      type="button"
                      className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 w-full ${isActive('/chatLive')} ${is_chat ? 'block' : 'hidden'}`}
                    >
                      Chat en vivo
                    </button>
                  </Link>
                  <Link
                    to="/certificados"
                    className="nav-link Bebas-Neue text-items-nav w-full"
                    style={{ color: 'inherit' }}
                  >
                    <button
                      type="button"
                      className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 w-full ${isActive('/certificados')} ${is_chat ? 'hidden' : 'block'}`}
                    >
                      Certificado
                    </button>
                  </Link>
                </Sidebar.ItemGroup>
              </Sidebar.Items>
            </div>
            <div className="px-4 py-2 border-t border-gray-200 mt-auto">
              <span className="text-sm text-dark-purple-800 mb-2 block text-center">
                Bienvenido, <strong className='fw-bold'>{formatSpeakerName(name + ' ' + lastName)}</strong>
              </span>
              <button
                type="button"
                className="w-full h-10 flex items-center justify-center text-white bg-[#011965] rounded-full hover:text-[#0055D1] focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                onClick={logout}
              >
                Salir
              </button>
            </div>
          </Sidebar>
        </Drawer.Items>
      </Drawer>

    </>
  );
};


export const HeaderWithoutLogin = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const location = useLocation();

  const isActive = (path) => {
    // Verifica si la ruta actual comienza con el path proporcionado
    return location.pathname.startsWith(path) ? 'active' : '';
  }

  const handleLinkClick = () => {
    if (isOpen) {
      handleDrawerClick()
    }
  };

  const handleDrawerClick = () => {
    handleClose()
  }

  return (
    <>
      <Navbar fluid rounded className='bg-transparent rounded-0 ml-5 mr-5'>
        <div className="flex md:order-2 mr-5 flex-end justify-end">
          <Navbar.Toggle className="button" onClick={handleOpen} />
        </div>
        <Navbar.Collapse className="ml-auto mr-5">
          <div className="flex flex-col items-end">
            <div className="inline-flex" role="group">
              <Link
                to="/home"
                className="nav-link Bebas-Neue text-items-nav"
                style={{ color: 'inherit' }}
              >
                <button
                  type="button"
                  className={`px-4 py-2 rounded-l-full text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 ${isActive('/home')}`}
                >
                  Inicio
                </button>
              </Link>
              <Link
                to="/agenda"
                className="nav-link Bebas-Neue text-items-nav"
                style={{ color: 'inherit' }}
              >
                <button
                  type="button"
                  onClick={() => handleLinkClick('/eventos')}
                  className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 ${isActive('/agenda')}`}
                >
                  Agenda
                </button>
              </Link>
              <Link
                to="/conferencistas"
                className="nav-link Bebas-Neue text-items-nav"
                style={{ color: 'inherit' }}
              >
                <button
                  type="button"
                  className={`px-4 py-2 text-sm font-medium rounded-r-full text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 ${isActive('/conferencistas')}`}
                >
                  Conferencistas
                </button>

              </Link>
            </div>
          </div>
        </Navbar.Collapse>
      </Navbar>

      <Drawer open={isOpen} onClose={handleClose} className='drawer-personalited'>
        <Drawer.Header title="MENU" titleIcon={() => <></>} />
        <Drawer.Items>
          <Sidebar
            aria-label="Sidebar with multi-level dropdown example"
            className="[&>div]:bg-transparent [&>div]:p-0 px-0"
          >
            <img
              src="./logo_medicoinnovador_color.png"
              className="d-inline-block align-text-top text-center p-2 mx-5 w-40 h-24"
              alt="Logo"
            />
            <div className="flex flex-col flex-grow">
              <Sidebar.Items>
                <Sidebar.ItemGroup className="w-full">
                  <Link
                    to="/home"
                    className="nav-link Bebas-Neue text-items-nav w-full"
                    style={{ color: 'inherit' }}
                  >
                    <button
                      type="button"
                      className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 w-full ${isActive('/inicio')}`}
                    >
                      Inicio
                    </button>
                  </Link>
                  <Link
                    to="/agenda"
                    className="nav-link Bebas-Neue text-items-nav w-full"
                    style={{ color: 'inherit' }}
                  >
                    <button
                      type="button"
                      onClick={() => handleLinkClick('/eventos')}
                      className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 w-full ${isActive('/agenda')}`}
                    >
                      Agenda
                    </button>
                  </Link>
                  <Link
                    to="/conferencistas"
                    className="nav-link Bebas-Neue text-items-nav w-full"
                    style={{ color: 'inherit' }}
                  >
                    <button
                      type="button"
                      className={`px-4 py-2 text-sm font-medium text-[#011965] bg-transparent border-2 border-[#0055D1] border-r-0 w-full ${isActive('/conferencistas')}`}
                    >
                      Conferencistas
                    </button>
                  </Link>
                </Sidebar.ItemGroup>
              </Sidebar.Items>
            </div>
          </Sidebar>
        </Drawer.Items>
      </Drawer>

    </>
  );
};


export default HeaderComponent;
